import { isBefore, sub } from 'date-fns';
import isToday from 'date-fns/isToday';
import { useTranslation } from 'react-i18next';
import type { DayType } from './Day';
import styles from './DaySimple.module.css';
import RegistrationInputDebounced from './RegistrationInputDebounced';

type DaySimpleProps = {
  date: DayType;
  isExport?: boolean;
};

export const DaySimple = ({ date, isExport = false }: DaySimpleProps) => {
  const { t, i18n } = useTranslation();
  const { day, isWorkingDay, id, description } = date;
  const currentDate = new Date(date.currentDate);

  // Use built-in Date internationalization for weekday
  const getLocalizedWeekday = (date: Date) => {
    const locale = i18n.language === 'nb' ? 'nb-NO' : 'en-US';
    return date.toLocaleDateString(locale, { weekday: 'long' });
  };
  return (
    <div
      className={`${styles.dayWrapper} ${isExport ? styles.dayWrapperExport : ''}`}
      style={{
        color: !isWorkingDay ? 'red' : 'black',
        ...(!isExport && isToday(currentDate) && { border: '2px dotted lightgreen' }),
        background: isBefore(sub(new Date(), { days: 1 }), currentDate) && !isExport ? 'white' : '#eee',
      }}
    >
      <div className={styles.date}>{day}</div>
      <div className={styles.weekday}>{getLocalizedWeekday(currentDate)}</div>

      {!isExport && (
        <div className={styles.description}>
          <RegistrationInputDebounced
            registrationId={id}
            label={t('salary.note')}
            propertyName="description"
            value={description}
            textArea
          />
        </div>
      )}
    </div>
  );
};
